import { Button as MuiButton } from '@material-ui/core';
import { useLocation } from 'react-router-dom';
import { Add } from '@material-ui/icons';
import { Button } from '../../../DesignSystem/Inputs';
import { translate } from '@utils';
import { AddRoundIcon } from '@images/icons';

export const MultipleAddButton = (props) => {
  const { handleAdd } = props;
  const location = useLocation();

  return (
    <>
      {!location.pathname.includes('questionnaire') ? (
        <div className="multiple-form-buttons">
          <Button onClick={handleAdd} endIcon={<Add />} type="tertiary">
            {translate('add')}
          </Button>
        </div>
      ) : (
        <div className="multiple-form-buttons">
          <MuiButton
            className="add-button"
            variant="contained"
            data-testid="add-button"
            onClick={handleAdd}
            endIcon={<AddRoundIcon />}
            disableRipple
          />
        </div>
      )}
    </>
  );
};
